<h4 mat-dialog-title>Bulk Upload Details</h4>

<div mat-dialog-content>
	<div id="msg">
		{{ msg }}
	</div>
</div>

<div mat-dialog-actions style="display: flex;justify-content: flex-end;">
	<div *ngFor="let button of buttons">
		<button mat-button cdkFocusInitial mat-dialog-close class="btn" (click)="closeModal()">{{ button }}</button>
	</div>
</div>